import {
  Entity,
  Column,
  Index,
  JoinColumn,
  ManyToOne,
  PrimaryGeneratedColumn,
} from "typeorm";
import { LicenseType, Project, StripeOrder } from "./";
import { User } from "./User";
import { Work } from "./Work";

@Entity()
@Index(["status", "user", "version"])
@Index(["uuid", "version"], { unique: true })
export class LicenseRequest {
  @PrimaryGeneratedColumn() id: number;

  @Column("varchar") status: string;

  @Column("int", { nullable: true })
  version: number | null;

  @Column("int", { nullable: true })
  licenseTypeId: number | null;
  @ManyToOne(() => LicenseType, (licenseType) => licenseType.licenseRequests)
  @JoinColumn()
  licenseType: LicenseType;

  @Column("int", { nullable: true })
  projectId: number | null;
  @ManyToOne(() => Project)
  @JoinColumn()
  project: Project;

  @Column("int") workId: number;
  @ManyToOne(() => Work, (work) => work.licenseRequests)
  @JoinColumn()
  work: Work;

  @Column("int", { nullable: false, default: 0 })
  workCopyNumber: number;

  @Column("int") userId: number;
  @ManyToOne(() => User)
  @JoinColumn()
  user: User;

  @Column({ nullable: true, type: "integer" })
  stripeOrderId: number | null;
  @ManyToOne(() => StripeOrder)
  @JoinColumn()
  stripeOrder: StripeOrder;

  @Column("text") updateReason: string;

  @Column("datetime", { nullable: true })
  expiration: Date | null;

  @Column("text") contractKey: string;

  @Column("datetime") createdAt: Date;

  @Column("datetime") updatedAt: Date;

  @Column("varchar") uuid: string;

  @Column("datetime", { nullable: true })
  decisionDate: Date | null;

  @Column("datetime", { nullable: true })
  requestedDate: Date | null;

  @Column("tinyint", { default: false })
  signedByUser: boolean;

  @Column("datetime", { nullable: true })
  signedByUserDate: Date | null;

  @Column("tinyint", { default: false })
  signedByIntegrity: boolean;

  @Column("datetime", { nullable: true })
  signedByIntegrityDate: Date | null;

  @Column("datetime", { nullable: true })
  approvedAt: Date | null;

  @Column("int", { nullable: true })
  approvedById: number | null;
  @ManyToOne(() => User)
  @JoinColumn()
  approvedBy: User;

  @Column("int", { nullable: true })
  updateRequestedById: number | null;
  @ManyToOne(() => User)
  @JoinColumn()
  updateRequestedBy: User | null;

  @Column("datetime", { nullable: true })
  updateRequestedAt: Date | null;

  @Column("datetime", { nullable: true })
  completedAt: Date | null;

  @Column("datetime", { nullable: true })
  completedDate: Date | null;

  @Column("varchar", { nullable: true })
  voidReason?: string | null;

  @Column("datetime", { nullable: true }) voidedAt?: Date | null;

  @Column("int", { nullable: true })
  voidedById?: number | null;

  @ManyToOne(() => User)
  @JoinColumn()
  voidedBy?: User;

  @Column("tinyint", { default: 0 }) opened: boolean;

  @Column("varchar", { nullable: true })
  adminNotes?: string | null;
}
